import { handleResponseError } from './handleResponseError.js';
import { apiUrl } from '@/api/axios.js';

export const getTestListData = (slice: any, url: any) => (page: number) => async (dispatch, getState) => {
    dispatch(slice.actions.fetchDataStart());
    try {
        const response = await apiUrl.get(`${url}${page}`, { withCredentials: true });
        const data = response.data;
        const items = data.data;
        const lastPage = data.last_page;
        dispatch(slice.actions.setDataLoaded(items));

        const { isLastPageSet } = getState()[slice.name];
        if (!isLastPageSet) {
            dispatch(slice.actions.setLastPage(lastPage));
        }
    } catch (error) {
        handleResponseError(error, (errorMessage) => dispatch(slice.actions.fetchDataError(errorMessage)));
    }
};
